export function VideoItem(props: { autoplay?: boolean, poster?: string }) {
    const addProps = props.autoplay ? { autoplay: true } : {};
    return <video {...addProps} muted playsinline disablePictureInPicture webkit-playsinline></video>
}